import { TaskNote, TaskNoteStatus } from '@/types/TaskNote.ts'
import moment from 'moment/moment'

export function sortTaskNote(a: TaskNote, b: TaskNote): number {
    const priorityStatus: TaskNoteStatus[] = [TaskNoteStatus.schedule, TaskNoteStatus.todo, TaskNoteStatus.inProgress]

    const aIsPriority: boolean | undefined = a.status && priorityStatus.includes(a.status)
    const bIsPriority: boolean | undefined = b.status && priorityStatus.includes(b.status)

    // Priorité aux status
    if (aIsPriority && !bIsPriority) return -1
    if (!aIsPriority && bIsPriority) return 1

    if (aIsPriority && bIsPriority && a.date && b.date) {
        // Si même catégorie, trier par updateDate décroissant (plus récent d'abord)
        return moment(a.date, 'DD-MM-YYYY').diff(moment(b.date, 'DD-MM-YYYY'))
    }

    // Ensuite les TaskNote de type "note"
    if (a.type === 'note' && b.type !== 'note') return -1
    if (a.type !== 'note' && b.type === 'note') return 1

    // Enfin le reste, trié par updateDate décroissant
    return new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
}
